function initializeLazyLoad() {
    var lazyImages = [].slice.call(document.querySelectorAll("img.lazy, source.lazy"));

    if ("IntersectionObserver" in window) {
        var lazyImageObserver = new IntersectionObserver(function(entries, observer) {
            entries.forEach(function(entry) {
                if (entry.isIntersecting) {
                    var lazyImage = entry.target;

                    // Para elementos IMG que ainda têm a classe 'lazy'
                    if (lazyImage.tagName === "IMG" && lazyImage.classList.contains('lazy')) {
                        lazyImage.src = lazyImage.dataset.src;
                        lazyImage.classList.remove("lazy");
                        lazyImageObserver.unobserve(lazyImage);
                    }

                    // Para elementos SOURCE dentro de <picture>
                    if (lazyImage.tagName === "SOURCE" && lazyImage.classList.contains('lazy')) {
                        lazyImage.srcset = lazyImage.dataset.srcset;
                        var parentPicture = lazyImage.parentNode;
                        
                        // Encontra o elemento <img> associado dentro do mesmo <picture>
                        var imgTag = parentPicture.querySelector('img');
                        if (imgTag) {
                            // Força a atualização do <img> para garantir que o navegador reavalie o <source>
                            imgTag.src = imgTag.dataset.src;
                            imgTag.onload = function() {
                                lazyImage.classList.remove("lazy");
                                imgTag.classList.remove("lazy");
                            };
                        }
                        
                        lazyImageObserver.unobserve(lazyImage);
                    }
                }
            });

        }, {
            rootMargin: "300px 0px" // Carrega 300px antes de aparecer na tela
        });

        lazyImages.forEach(function(lazyImage) {
            lazyImageObserver.observe(lazyImage);
        });

        // Rede de segurança: um salto direto no scroll (arrastar a barra até o
        // fim, âncora, F5 com a página já rolada) não gera interseção para o
        // que ficou no meio do caminho — as imagens puladas travavam no
        // placeholder transparente e só carregavam se o visitante subisse de
        // volta. Aqui varremos o que sobrou pela posição real.
        varreRestantes(lazyImages, lazyImageObserver);
    } else {
        // Fallback para navegadores que não suportam IntersectionObserver
        lazyImages.forEach(function(lazyImage) {
            if (lazyImage.tagName === "IMG" && lazyImage.classList.contains('lazy')) {
                lazyImage.src = lazyImage.dataset.src;
                lazyImage.classList.remove("lazy");
            } else if (lazyImage.tagName === "SOURCE" && lazyImage.classList.contains('lazy')) {
                lazyImage.srcset = lazyImage.dataset.srcset;
                // Aqui não precisamos recarregar o <img> porque estamos no fallback
            }
        });
    }
}


// Ativa na marra o que ainda estiver marcado como lazy e já esteja dentro da
// margem de carregamento — o observer continua sendo o caminho normal, isto é
// só o resgate de quem ele não viu passar.
function varreRestantes(lazyImages, observer) {
    var MARGEM = 300;
    var agendado = false;

    function ativar(el) {
        if (!el.classList.contains('lazy')) return;

        if (el.tagName === "IMG") {
            el.src = el.dataset.src;
            el.classList.remove("lazy");
        } else if (el.tagName === "SOURCE") {
            el.srcset = el.dataset.srcset;
            var img = el.parentNode.querySelector('img');
            if (img && img.dataset.src) img.src = img.dataset.src;
            el.classList.remove("lazy");
            if (img) img.classList.remove("lazy");
        }

        if (observer) observer.unobserve(el);
    }

    function varrer() {
        agendado = false;
        var altura = window.innerHeight || document.documentElement.clientHeight;
        var restantes = 0;

        lazyImages.forEach(function(el) {
            if (!el.classList.contains('lazy')) return;

            // <source> não tem caixa própria: medimos pelo <picture> em volta.
            var alvo = el.tagName === "SOURCE" ? (el.parentNode || el) : el;
            var caixa = alvo.getBoundingClientRect();

            if (caixa.top - MARGEM < altura && caixa.bottom + MARGEM > 0) {
                ativar(el);
            } else {
                restantes++;
            }
        });

        if (!restantes) {
            window.removeEventListener('scroll', agendar);
            window.removeEventListener('resize', agendar);
        }
    }

    function agendar() {
        if (agendado) return;
        agendado = true;
        window.requestAnimationFrame(varrer);
    }

    window.addEventListener('scroll', agendar, { passive: true });
    window.addEventListener('resize', agendar, { passive: true });
    window.addEventListener('load', agendar);
    agendar();
}

// Inicializa o lazy load após o carregamento do DOM
document.addEventListener("DOMContentLoaded", initializeLazyLoad);
